export enum InformerTypeEnum {
  TASK = 'TASK',
  CATALOG = 'CATALOG',
  BUDGET = 'BUDGET',
  SYSTEM = 'SYSTEM',
}
